import React from 'react';
import ReactDOM from 'react-dom';
import BookingApp from './components/BookingApp';
import './styles/BookingApp.css';

const container = document.getElementById('booking-app');
if (container) {
  // Vérifie si on est en React 18
  const isReact18 = typeof ReactDOM.createRoot === 'function';

  if (isReact18) {
    // React 18
    const root = ReactDOM.createRoot(container);
    root.render(<BookingApp />);
  } else {
    // Compatibilité React 17
    ReactDOM.render(<BookingApp />, container);
  }
}